import {
  Box,
  Grid,
  Drawer,
  Button,
  Typography,
  ThemeProvider,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Dialog, DialogProps } from '../../dialogs';
import { useBreakpointQuery } from '../../../utils';
import { Formik, FormikHelpers } from 'formik';
import { JFields } from './JFormik';
import { JItem, JFormikProps } from './jformik.types';
import { JFormikContext } from './jformik.context';
import { BackdropLoading } from '../../BackdropLoading';
import { ScrollToRef } from '../../ScrollToRef';
import { useRef, useEffect } from 'react';
import { theme } from '../../../config';

export interface DialogFormV2Props extends DialogProps, JFormikProps {
  alternate?: any;
  openAlternate?: boolean;
  closeAlternate?: Function;
}

export const DialogFormV2 = (props: DialogFormV2Props) => {
  const {
    handleSubmit,
    initialValues,
    validationSchema,
    form,
    alternate,
    openAlternate,
    closeAlternate = () => {},
    loading,
    ...rest
  } = props;
  const smDown = useBreakpointQuery('sm-down');
  const scrollRef = useRef<HTMLElement>(null);
  const scrollToRef = () => {
    if (scrollRef && scrollRef.current) {
      setTimeout(function () {
        scrollRef &&
          scrollRef.current &&
          scrollRef.current.scrollIntoView({ behavior: 'smooth' });
      }, 500);
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (!!openAlternate) {
      scrollToRef();
    }
  }, [openAlternate]);

  return (
    <Dialog {...rest}>
      <Box id="container">
        <Drawer
          PaperProps={{
            style: {
              position: 'absolute',
              border: 'none',
            },
            sx: { width: '100%' },
          }}
          ModalProps={{
            container: document.getElementById('container'),
            disableEnforceFocus: true,
            style: { position: 'absolute' },
          }}
          sx={{ width: '100%' }}
          variant="persistent"
          anchor="left"
          open={!!openAlternate}
          onClose={() => closeAlternate()}
        >
          <Box>
            <span ref={scrollRef}></span>
            {alternate}
          </Box>
        </Drawer>
        {loading ? (
          <BackdropLoading relative />
        ) : (
          <Box sx={{ visibility: !!openAlternate ? 'hidden' : 'visible' }}>
            <ThemeProvider theme={theme}>
              <JFormikContext.Provider
                value={{
                  disabled: props.disabled,
                  disableSubmitOnEnter: props.disableSubmitOnEnter,
                }}
              >
                <Formik
                  initialValues={
                    initialValues
                      ? typeof initialValues === 'function'
                        ? initialValues()
                        : initialValues
                      : {}
                  }
                  enableReinitialize
                  onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
                    handleSubmit
                      ? handleSubmit(values, formikHelpers)
                      : console.info(values)
                  }
                  validationSchema={props.validationSchema}
                >
                  {({ handleSubmit, values, errors }) => {
                    {
                      errors &&
                        Object.keys(errors).length > 1 &&
                        console.error(errors);
                    }
                    return (
                      <form
                        onSubmit={(event: any) => {
                          handleSubmit(event);
                        }}
                      >
                        <Box
                          sx={{
                            paddingY: 4,
                          }}
                        >
                          <Grid
                            container
                            spacing={2}
                            sx={{ px: { xs: 0, sm: 4 } }}
                          >
                            <JFields items={props.form} />
                          </Grid>
                        </Box>
                        {false && <pre>{JSON.stringify(values, null, 2)}</pre>}
                      </form>
                    );
                  }}
                </Formik>
              </JFormikContext.Provider>
            </ThemeProvider>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
